import { EssentialsPartialDelegate } from './EssentialsPartialDelegate';
export class ChildEssentials {
    constructor({ parent, ...options }) {
        this.createChildEssentials = (options = {}) => {
            return new ChildEssentials({
                ...options,
                parent: this,
            });
        };
        this._parent = parent;
        this._delegate = new EssentialsPartialDelegate({
            ...options,
            parent: this._parent,
        });
    }
    get asPartial() {
        return this._delegate;
    }
    get experiments() {
        return this._delegate.getExperiments(this._parent);
    }
    get fedopsLogger() {
        return this._delegate.getFedopsLogger(this._parent);
    }
    get errorMonitor() {
        return this._delegate.getErrorMonitor(this._parent);
    }
    get i18n() {
        return this._delegate.getI18n(this._parent);
    }
    get biLoggerFactory() {
        return this._delegate.getBILoggerFactory(this._parent);
    }
    get biLogger() {
        return this._delegate.getBILogger(this._parent);
    }
    get httpClient() {
        return this._delegate.getHttpClient(this._parent);
    }
    get errorHandler() {
        return this._delegate.getErrorHandler(this._parent);
    }
    get dataCapsule() {
        return this._delegate.getDataCapsule(this._parent);
    }
    get createCurrencyFormatter() {
        return this._delegate.getCreateCurrencyFormatter(this._parent);
    }
    get formatAddress() {
        return this._delegate.getFormatAddress(this._parent);
    }
    get abTranslate() {
        return this._delegate.getAbTranslate(this._parent);
    }
    get environment() {
        return this._parent.environment;
    }
    get panoramaClient() {
        return this._delegate.getPanoramaClient(this._parent);
    }
}
//# sourceMappingURL=ChildEssentials.js.map